import { defaultPreferredUsername } from '../../constants/defaultPreferredUsername';
import { CustomDataAttrGtmClick } from '../../features/google/customDataType';
import { defaultProfileImageUrl } from '../../features/url/baseUrl';
import { DefaultProps } from '../../types/DefaultProps';
import { ComponentProps as IconProps } from '../Icon/Icon';

import styles from './HeaderProfileButton.module.scss';

import type { LoggedInUser } from '../../types/LoggedInUser';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC, ComponentType, ReactNode } from 'react';

type Props = DefaultProps & {
  appEnv: AppEnv;
  icon: ComponentType<IconProps>;
  children?: ReactNode;
  link?: string;
  loggedInUser?: LoggedInUser;
  customDataAttrGtmClick?: CustomDataAttrGtmClick;
};

export const HeaderProfileButton: FC<Props> = ({
  appEnv,
  link,
  loggedInUser,
  customDataAttrGtmClick = '',
}) => (
  <a
    className={styles.wrap}
    href={link}
    data-gtm-click={customDataAttrGtmClick}
  >
    <div className={styles['box-profile']}>
      <div className={styles['box-profile-photo']}>
        {loggedInUser?.pictureUrl ? (
          <img
            src={loggedInUser?.pictureUrl}
            alt={loggedInUser?.preferredUsername}
          />
        ) : (
          <img src={defaultProfileImageUrl(appEnv)} alt="写真未設定" />
        )}
      </div>
      <div className={styles['box-profile-right']}>
        <span className={styles['text-profile']}>
          {loggedInUser?.preferredUsername
            ? loggedInUser?.preferredUsername
            : defaultPreferredUsername}
          さん
        </span>
      </div>
    </div>
    <span className={styles.text}>マイページ</span>
  </a>
);
